// extracted by mini-css-extract-plugin
module.exports = {"left":"_3r9I0VhSePjfnn7c-awv5R","right":"_1F2WBlP5crzf-4Lg_vJYHO"};